// test1281
(1281 && 0);
